import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  getPoliticsAndProcedures,
  savePoliticsAndProcedures,
  editPoliticsAndProcedures,
  deletePoliticsAndProcedures,
} from "../../../redux/descriptorsProfiles/PoliticsAndProcedures/actions";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import config from "../../../config";
import { get_tasks } from "../../../redux/tasks/actions";
import {
  getGeneralInfo,
  resetGeneralInfo,
} from "../../../redux/descriptorsProfiles/GeneralInfo/actions";

const PoliticsAndProcedures = (props) => {
  const filters = [
    { id: "descriptor_nombre", desc: "Descriptor" },
    { id: "descripcion", desc: "Política y procedimiento" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [_funcion, setFuncion] = useState(false);
  const [funSelected, setFunSelected] = useState([]);
  const [descSelected, setDescSelected] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "descriptor_nombre",
    desc: "Descriptor",
  });

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    funcion: Yup.string().required("**Campo requerido"),
    descriptor: Yup.string().required("**Campo requerido"),
    // descriptor: Yup.string()
    //   .required("**Campo requerido")
    //   .matches(
    //     /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
    //     "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
    //   ),
    nombre: Yup.string().required("**Campo requerido"),
    descripcion: Yup.string().required("**Campo requerido"),
    url: Yup.string().required("**Campo requerido"),
    // llave: Yup.string()
    //   .required("**Campo requerido")
    //   .matches(
    //     /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
    //     "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
    //   ),
    // id_del_archivo: Yup.number()
    //   .required("**Campo requerido")
    //   .typeError("Debe especificar un numero")
    //   .min(0, "El número debe ser mayor a 0."),
  });

  const {
    loading,
    saveLoading,
    politicsAndProceduresLength,
    politicsAndProcedures,
    politicsAndProcedureError,
    formError,
    formErrorJson,
  } = useSelector((store) => store.politicsAndProcedure);
  const pages = Math.ceil(politicsAndProceduresLength / limit);
  const { generalInfos, generalInfosLength, generalInfoError } = useSelector(
    (store) => store.generalInfo
  );
  const loadingGeneralInfo = useSelector((store) => store.generalInfo.loading);

  // const { carpeta, tipoDocumento, tipoDocumentoGD, descripcion } =
  //   config.gestorDocumental.accion_disciplinaria;
  const { area, email } = config.gestorDocumental;

  const tasks = useSelector((store) => store.tasks.tasks);
  const tasksLoader = useSelector((store) => store.tasks.loader);

  let funcionOptions = [];
  tasks &&
    tasks.map((task) => {
      funcionOptions = [
        ...funcionOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
        },
      ];
    });
  let descriptorOptions = [];
  generalInfos &&
    generalInfos.map((gen) => {
      descriptorOptions = [
        ...descriptorOptions,
        {
          id: gen.id,
          label: gen.nombre_posicion.toUpperCase(),
        },
      ];
    });

  const columns = [
    {
      Header: "Descriptor",
      accessor: "list_descriptor[0].nombre_posicion",
    },
    {
      Header: "Política y procedimiento",
      accessor: "nombre",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Eliminar</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
          {/* {value.row.original.archivo && (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Descargar archivo</Tooltip>}
              >
                <div>
                  <LinkDescargaListGD
                    id={value.row.original.id}
                    filters={{
                      email: email,
                      id: value.row.original.list_archivo[0].id_documento,
                      llave: value.row.original.list_archivo[0].llave,
                    }}
                    origen={value.row.original.list_archivo[0].origen}
                    icono={<i className="material-icons">file</i>}
                    cType={value.row.original.list_archivo[0].contentTypeGD}
                  />
                </div>
              </OverlayTrigger>
            </>
          )} */}
          {value.row.original.url && value.row.original.url !== "" && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Url gestor documental</Tooltip>}
            >
              <Button
                size="sm"
                variant="link"
                type="button"
                className="text-info rounded"
                onClick={() => {
                  const win = window.open(value.row.original.url);
                  win.focus();
                }}
              >
                <i className="material-icons">link</i>
              </Button>
            </OverlayTrigger>
          )}
        </div>
      ),
    },
  ];

  // Métodos
  const _getPoliticsAndProcedures = (
    offs = offset,
    lim = limit,
    filt = filter
  ) =>
    dispatch(
      getPoliticsAndProcedures({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
      })
    );

  useEffect(() => {
    _getPoliticsAndProcedures();
    dispatch(get_tasks({}));
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setEditItem({});
    setValidated(false);
    dispatch(resetGeneralInfo());
  };

  const onEdit = (item, index) => {
    setFunSelected([
      {
        id: item.list_descriptor[0].posicion,
        label: item.list_descriptor[0].list_posicion[0].descripcion
          ? `${
              item.list_descriptor[0].list_posicion[0].codigo
            } / ${item.list_descriptor[0].list_posicion[0].descripcion.toUpperCase()}`
          : "",
      },
    ]);
    setFuncion(true);
    dispatch(
      getGeneralInfo({
        tipo_busqueda: "posicion_id",
        filter: parseInt(item.list_descriptor[0].posicion),
      })
    );
    setDescSelected([
      {
        id: item.descriptor,
        label: item.list_descriptor[0].nombre_posicion,
      },
    ]);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
    dispatch(resetGeneralInfo());
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPoliticsAndProcedures(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = {
      nombre: req.nombre,
      descripcion: req.descripcion,
      descriptor: req.descriptor,
      url: req.url,
    };

    if (!edit) {
      dispatch(savePoliticsAndProcedures(_req, setShowModal));
    } else {
      dispatch(
        editPoliticsAndProcedures(_req, editItem.id, index, setShowModal)
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPoliticsAndProcedures(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePoliticsAndProcedures(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              políticas y procedimientos
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            politicsAndProceduresLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={politicsAndProcedures}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={politicsAndProceduresLength}
                  pages={pages}
                  pagFunc={_getPoliticsAndProcedures}
                />
              </>
            )
          )}
          {!loading &&
            politicsAndProceduresLength === 0 &&
            politicsAndProcedureError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!politicsAndProcedureError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {politicsAndProcedureError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setFuncion(false);
          setFunSelected([]);
          setDescSelected([]);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            funcion: edit
              ? editItem.list_descriptor[0].posicion === null
                ? ""
                : editItem.list_descriptor[0].posicion
              : "",
            descriptor: edit
              ? editItem.descriptor === null
                ? ""
                : editItem.descriptor
              : "",
            // descriptor: edit ? editItem.descriptor : "",
            nombre: edit ? editItem.nombre : "",
            descripcion: edit ? editItem.descripcion : "",
            url: edit ? editItem.url : "",
            // llave: edit ? editItem.llave : "",
            id_del_archivo: edit ? editItem.id_del_archivo : null,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit
                    ? "Editar políticas y procedimientos"
                    : "Crear políticas y procedimientos"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Función
                  </Form.Label>
                  <Typeahead
                    id="funcion"
                    name="funcion"
                    isInvalid={touched.funcion && errors.funcion}
                    isValid={touched.funcion && !errors.funcion}
                    onBlur={handleBlur("funcion")}
                    placeholder="Función"
                    options={funcionOptions}
                    onChange={(selected) => {
                      setFieldValue(
                        "funcion",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setFunSelected(selected);
                      setFuncion(selected.length > 0);
                      if (selected.length > 0) {
                        dispatch(
                          getGeneralInfo({
                            tipo_busqueda: "posicion_id",
                            filter: parseInt(selected[0].id),
                          })
                        );
                      }
                    }}
                    selected={funSelected}
                    disabled={tasks.length === 0}
                  ></Typeahead>
                  {tasksLoader && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.funcion && errors.funcion && (
                    <Col>
                      <small className="text-danger">{errors.funcion}</small>
                    </Col>
                  )}
                  {!!generalInfoError && (
                    <Col>
                      <small className="text-danger">
                        **{generalInfoError}
                      </small>
                    </Col>
                  )}
                  {!tasksLoader && tasks.length === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron funciones
                      </small>
                    </Col>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Descriptor
                  </Form.Label>
                  <Typeahead
                    id="descriptor"
                    name="descriptor"
                    isInvalid={
                      (touched.descriptor && errors.descriptor) ||
                      (touched.descriptor &&
                        formErrorJson &&
                        typeof formErrorJson === "object" &&
                        formErrorJson.descriptor)
                    }
                    isValid={touched.descriptor && !errors.descriptor}
                    onBlur={handleBlur("descriptor")}
                    placeholder="Descriptor"
                    options={descriptorOptions}
                    onChange={(selected) => {
                      setFieldValue(
                        "descriptor",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setDescSelected(selected);
                    }}
                    selected={descSelected}
                    disabled={
                      !_funcion ||
                      generalInfosLength === 0 ||
                      loadingGeneralInfo
                    }
                  ></Typeahead>
                  {loadingGeneralInfo && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.descriptor && errors.descriptor && (
                    <Col>
                      <small className="text-danger">{errors.descriptor}</small>
                    </Col>
                  )}
                  {!!generalInfoError && (
                    <Col>
                      <small className="text-danger">
                        **{generalInfoError}
                      </small>
                    </Col>
                  )}
                  {generalInfosLength === 0 && _funcion && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron descriptores para esta función
                      </small>
                    </Col>
                  )}
                  {!_funcion && (
                    <Col>
                      <small className="text-danger">
                        **Seleccione una función para mostrar descriptores
                      </small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.descriptor ? (
                    <Col>
                      {formErrorJson.descriptor.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
                {/* <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descriptor
                  </Form.Label>
                  <Form.Control
                    id="descriptor"
                    name="descriptor"
                    isInvalid={touched.descriptor && errors.descriptor}
                    isValid={touched.descriptor && !errors.descriptor}
                    onBlur={handleBlur("descriptor")}
                    onChange={handleChange}
                    value={values.descriptor}
                    className="rounded-pill"
                    type="text"
                    placeholder="Descriptor"
                    disabled={!_funcion}
                  ></Form.Control>
                  {touched.descriptor && errors.descriptor && (
                    <div>
                      <small className="text-danger">{errors.descriptor}</small>
                    </div>
                  )}
                </Form.Group> */}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Política y procedimiento
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={
                      (touched.nombre && errors.nombre) ||
                      (touched.nombre &&
                        formErrorJson &&
                        typeof formErrorJson === "object" &&
                        formErrorJson.nombre)
                    }
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    type="text"
                    className="rounded-pill"
                    placeholder="Política y procedimiento"
                  ></Form.Control>
                  {touched.nombre && errors.nombre && (
                    <Col>
                      <small className="text-danger">{errors.nombre}</small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.nombre ? (
                    <Col>
                      {formErrorJson.nombre.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción
                  </Form.Label>
                  <Form.Control
                    id="descripcion"
                    name="descripcion"
                    isInvalid={
                      (touched.descripcion && errors.descripcion) ||
                      (touched.descripcion &&
                        formErrorJson &&
                        typeof formErrorJson === "object" &&
                        formErrorJson.descripcion)
                    }
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    as="textarea"
                  ></Form.Control>
                  {touched.descripcion && errors.descripcion && (
                    <Col>
                      <small className="text-danger">
                        {errors.descripcion}
                      </small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.descripcion ? (
                    <Col>
                      {formErrorJson.descripcion.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Url gestor documental
                  </Form.Label>
                  <Form.Control
                    id="url"
                    name="url"
                    isInvalid={
                      (touched.url && errors.url) ||
                      (touched.url &&
                        formErrorJson &&
                        typeof formErrorJson === "object" &&
                        formErrorJson.url)
                    }
                    isValid={touched.url && !errors.url}
                    onBlur={handleBlur("url")}
                    onChange={handleChange}
                    value={values.url}
                    type="text"
                    className="rounded-pill"
                    placeholder=""
                  ></Form.Control>
                  {touched.url && errors.url && (
                    <Col>
                      <small className="text-danger">{errors.url}</small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.url ? (
                    <Col>
                      {formErrorJson.url.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
                {/* <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Llave
                  </Form.Label>
                  <Form.Control
                    id="llave"
                    name="llave"
                    isInvalid={touched.llave && errors.llave}
                    isValid={touched.llave && !errors.llave}
                    onBlur={handleBlur("llave")}
                    onChange={handleChange}
                    value={values.llave}
                    className="rounded-pill"
                    type="text"
                    placeholder="Llave"
                  ></Form.Control>
                  {touched.llave && errors.llave && (
                    <div>
                      <small className="text-danger">{errors.llave}</small>
                    </div>
                  )}
                </Form.Group> */}
                {/* <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Id del archivo
                  </Form.Label>
                  <Form.Control
                    id="id_del_archivo"
                    name="id_del_archivo"
                    isInvalid={
                      (touched.id_del_archivo && errors.id_del_archivo) ||
                      (touched.id_del_archivo &&
                        formErrorJson &&
                        typeof formErrorJson === "object" &&
                        formErrorJson.archivo)
                    }
                    isValid={touched.id_del_archivo && !errors.id_del_archivo}
                    onBlur={handleBlur("id_del_archivo")}
                    onChange={handleChange}
                    value={values.id_del_archivo}
                    className="rounded-pill"
                    type="number"
                    placeholder="Id del archivo"
                  ></Form.Control>
                  {touched.id_del_archivo && errors.id_del_archivo && (
                    <Col>
                      <small className="text-danger">
                        {errors.id_del_archivo}
                      </small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.archivo ? (
                    <Col>
                      {formErrorJson.archivo.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group> */}
                {edit && editItem.url !== "" ? (
                  <Col>
                    <h6 className="text-muted ml-3">Url actual</h6>
                    <ul className="list-unstyled">
                      <Button
                        size="sm"
                        variant="link"
                        type="button"
                        className="text-info rounded"
                        onClick={() => {
                          const win = window.open(editItem.url);
                          win.focus();
                        }}
                      >
                        {editItem.url}
                      </Button>
                    </ul>
                  </Col>
                ) : null}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default PoliticsAndProcedures;
